import { makeStyles } from "@mui/styles";

const useStyles = makeStyles(() => ({
  dialogPaper: {
    borderRadius: "16px !important",
    overflow: "hidden !important",
    maxWidth: "480px !important",
    width: "100% !important",
  },
  headerBar: {
    backgroundColor: "#d32f2f !important",
    color: "#ffffff !important",
    padding: "14px 24px !important",
    display: "flex !important",
    alignItems: "center !important",
    justifyContent: "space-between !important",
  },
  headerTitle: {
    fontSize: "18px !important",
    fontWeight: "600 !important",
    color: "#ffffff !important",
    fontFamily: "'Inter', sans-serif !important",
  },
  closeIconBtn: {
    color: "#ffffff !important",
    padding: "4px !important",
  },
  contentContainer: {
    padding: "28px 32px !important",
    backgroundColor: "#ffffff",
    textAlign: "center",
  },
  messageText: {
    fontSize: "15px !important",
    color: "#333333 !important",
    marginTop: "12px !important",
    fontFamily: "'Inter', sans-serif !important",
  },
  buttonContainer: {
    display: "flex",
    gap: "16px",
    justifyContent: "center",
    marginTop: "24px",
  },
  cancelBtn: {
    minWidth: "120px !important",
    height: "40px !important",
    borderRadius: "8px !important",
    textTransform: "none !important",
    borderColor: "#b0b0b0 !important",
    color: "#333333 !important",
    fontWeight: "600 !important",
    fontSize: "14px !important",
    fontFamily: "'Inter', sans-serif !important",
  },
  deleteBtn: {
    minWidth: "130px !important",
    height: "40px !important",
    borderRadius: "8px !important",
    textTransform: "none !important",
    backgroundColor: "#d32f2f !important",
    color: "#ffffff !important",
    fontWeight: "600 !important",
    fontSize: "14px !important",
    fontFamily: "'Inter', sans-serif !important",
    boxShadow: "none !important",
    "&:hover": {
      backgroundColor: "#b71c1c !important",
      boxShadow: "none !important",
    },
  },
}));

export default useStyles;
